import { render, staticRenderFns } from "./uploadPicture.vue?vue&type=template&id=3ed2dc7a"
import script from "./uploadPicture.vue?vue&type=script&lang=js"
export * from "./uploadPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports